const myStyles = theme => ({
  chatBottomDiv: {
    marginBottom: theme.spacing(2),
    width: "100%"
  },

  msgText: {
    overflowWrap: "break-word",
    ...theme.typography.h6,
    color:'white'
  },

  msgTime: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2),
    float: "right",
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: 1.66,
    letterSpacing: "0.03333em",
    color:'white',
  },

  dateBox: {
    // transform: "translateX(-50%)",
    width: "max-content",
    padding: "8px 16px 8px 16px",
    margin: "16px 0px 8px 0px",
    backgroundColor: "rgba(0,0,0,0.5)",
    borderRadius: "20px",
    // marginLeft: "50%",
    display:'inline-block',
    color:'white'
  }
});

export default myStyles;
